module.exports = __webpack_public_path__ + "img/676-18ed4c.png";